import * as React from "react";
import { PureComponent } from "react";
import * as cs_ from "classnames";

// Inaccurate definitions of the 'classnames' package
const cs: any = cs_ as any;

export interface Tag {
  key: string;
  name: string;
}

interface TagProps {
  className: string;
  tag: Tag;
  onClick(tag: Tag): void;
}

class TagItem extends PureComponent<TagProps> {
  onClick = () => this.props.onClick(this.props.tag);

  onTouchStart = (e: any) => {
    e.preventDefault();
    this.onClick();
  };

  render() {
    const { className, tag } = this.props;

    return (
      <div className={className} onClick={this.onClick} onTouchStart={this.onTouchStart}>
        {tag.name}
      </div>
    );
  }
}

interface TagFilterProps {
  tabKey: string;
  tabTitle: string;
  tags: Tag[];
  selectedTags: string[];
  modifiers?: string;
  onClick(tag: Tag): void;
}

class TagFilter extends PureComponent<TagFilterProps> {
  render() {
    const { tags, selectedTags, modifiers = "", onClick } = this.props;
    const selectionClass = (d: Tag) =>
      cs({
        "is-selected": selectedTags.indexOf(d.key) !== -1,
      });

    return (
      <div className={"tag-filter " + modifiers}>
        {tags.map((tag) => (
          <TagItem
            key={tag.key}
            className={"tag-filter__item " + selectionClass(tag) + " tag-filter__item__" + tag.key}
            onClick={onClick}
            tag={tag}
          />
        ))}
      </div>
    );
  }
}

export default TagFilter;
